import {Input, Rate, Select} from "antd";

export const SkillForm = ({id,onRemove}) => {
    const stars = [1, 2, 3, 4, 5];
    return (
    <div className={"w-full grid grid-cols-3 gap-4 border rounded-lg p-4 shadow-md"}>
        <div className={""}>
            <label className={"block"}>Kỹ năng</label>
            <Input placeholder="Nhập kỹ năng" className={"w-full border rounded-lg"} />
        </div>
        <div className={""}>
            <label className={"block"}>Đánh giá<span className={"text-red-50"}>*</span></label>
            <Select placeholder={"Chọn đánh giá"} className={"w-full"}>
                {stars.map((star) => (
                    <Select.Option key={star} value={star}
                        children={<Rate disabled defaultValue={star} />}/>
                ))}
            </Select>
        </div>
        <button className={"text-red-500 hover:underline"} onClick={() => onRemove(id)}>
            Xóa
        </button>
    </div>
    )
}